import React from 'react';
import cx from 'classnames';
import Richtext from '../global/richtext/Richtext';
import styles from './title-banner.module.scss';
import BannerProps from '../../models/title-banner';

type Props = {
  data: BannerProps;
};

const TitleBanner = ({ data }: Props) => {
  if (!data) return <></>;

  return (
    <div className={cx(styles.banner, 'container container__flex')}>
      {data.title && data.title.length && (
        <>
          <style>
            {`
                .${styles.banner__title}:before {
                  background-color: ${data.titleColor};
                }`}
          </style>
          <h1
            className={cx(
              styles.banner__title,
              'col-8 col-md-8 offset-md-2 col-lg-18 offset-lg-3'
            )}
            style={{ color: data.titleColor }}
          >
            {data.title}
          </h1>
        </>
      )}
      <div
        className={cx(
          styles['banner__subtitle-container'],
          'col-8 col-md-6 offset-md-8 col-lg-10 offset-lg-18'
        )}
      >
        {data.subtitle && <Richtext data={data.subtitle} />}
      </div>
    </div>
  );
};

export default TitleBanner;
